import React from "react";

export default function Duration({ className, milliseconds }) {
  return (
    <time
      dateTime={`PT${Math.round(milliseconds / 1000)}S`}
      style={{ fontWeight: "600", fontSize: "1rem" }}
      className={className}
    >
      {format(milliseconds)}
    </time>
  );
}

function format(ms) {
  const totalMs = Math.floor(ms);
  const date = new Date(totalMs);
  const hh = date.getUTCHours();
  const mm = date.getUTCMinutes();
  const ss = pad(date.getUTCSeconds());
  const msPart = padMs(totalMs % 1000);

  return `${pad(hh)}:${pad(mm)}:${ss}.${msPart}`;
}

function pad(num) {
  return String(num).padStart(2, "0");
}

function padMs(num) {
  return String(num).padStart(3, "0");
}
